export default __webpack_public_path__ + "static/media/gallery - story - other (1)_01.583069d9.jpg";